import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BarChart from '../chartjs/BarChart.vue';
import { Data, SeriesConfig } from '../../models';
import { computed, PropType } from 'vue';
import { useReportData } from '@/features/reports/util/useReportData';
import Report from '@/features/reports/components/Report.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BillableConversationsTrendChart',
  props: {
  data: {
    type: Object as PropType<Data>,
    required: true,
  },
  loadedData: {
    type: Boolean,
    default: false,
  },
  loadingError: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const { reportId, isDataEmpty, isDataLoaded, createBlankSeries } = useReportData(props);

const seriesOrder: SeriesConfig[] = [{ name: 'Conversations', displayName: 'Billable Conversations' }];

const reportData = computed<Data>(() => ({
  scale: props.data.scale,
  series: seriesOrder.map((seriesConfig) => {
    return (
      props.data.series.find((s) => s.name === seriesConfig.name) ||
      createBlankSeries(seriesConfig.name, seriesConfig.displayName)
    );
  }),
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Report, {
    "report-id": _unref(reportId),
    title: "Billable Conversations",
    "tooltip-text": "A billable conversation is classified as a contact who has sent at least one message in the month. If the contact has sent/received more than 20 messages in a month, each additional set of up to 20 messages is counted as another billable conversation.",
    class: "chart-container",
    "data-empty": _unref(isDataEmpty),
    "loaded-data": _unref(isDataLoaded),
    "loading-error": __props.loadingError
  }, {
    chart: _withCtx(() => [
      _createVNode(BarChart, {
        reportId: _unref(reportId),
        class: "chart",
        data: reportData.value,
        seriesOrder: seriesOrder
      }, null, 8, ["reportId", "data"])
    ]),
    _: 1
  }, 8, ["report-id", "data-empty", "loaded-data", "loading-error"]))
}
}

})